//* GETTER CONSTANT
export const getters = {
  GET_DEPT_LIST: 'GET_DEPT_LIST', //* DEPT 리스트 가져오기
  GET_DEPT_USER_LIST: 'GET_DEPT_USER_LIST', //* DEPT 리스트 가져오기
  GET_DEPT_CODE: 'GET_DEPT_CODE', //* 부서코드 중복체크
  GET_DEPT_INFO: 'GET_DEPT_INFO', //* 부서 상세 정보 가져오기
  GET_VIEWS_SRCH_DEPT_TREE: 'GET_VIEWS_SRCH_DEPT_TREE', //* 부서 추가 팝업
  GET_ASSIGNED_DEPT: 'GET_ASSIGNED_DEPT', //* 연계부서 가져오기
  GET_DEL_DEPT_HIDE: 'GET_DEL_DEPT_HIDE',
};

//* ACTION CONSTANT
/*
  ! FETCH, INSERT, UPDATE, DELETE: 비동기으로 인한 데이터 서버 전송 및 내부 STATE 변경 시
  ! INIT: 컴포넌트 내부에서 STATE 변경 시
  */
export const actions = {
  FETCH_DEPT_LIST: 'FETCH_DEPT_LIST', //* DEPT 리스트 가져오기
  FETCH_DEPT_USER_LIST: 'FETCH_DEPT_USER_LIST', //* DEPT USER 리스트 가져오기
  FETCH_DEPT_CODE: 'FETCH_DEPT_CODE', //* DEPT 코드 가져오기(중복체크)
  FETCH_ASSIGNED_DEPT: 'FETCH_ASSIGNED_DEPT', //* 연계부서 불러오기
  INSERT_DEPT_INFO: 'INSERT_DEPT_INFO', //* DEPT 추가.
  UPDATE_DEPT_USER_LIST: 'UPDATE_DEPT_USER_LIST', //* DEPT 직원 추가.
  UPDATE_DEPT_TREE: 'UPDATE_DEPT_TREE', //* Dept Tree 순서변경
  UPDATE_ASSIGNED_DEPT: 'UPDATE_ASSIGNED_DEPT', //* 연계부서 추가
  DELETE_ASSIGNED_DEPT: 'DELETE_ASSIGNED_DEPT', //* 연계부서 삭제
  INIT_ASSIGNED_DEPT: 'INIT_ASSIGNED_DEPT', //* 연계부서 초기화
  INIT_DEPT_INFO: 'INIT_DEPT_INFO', //* 부서 상세 정보 저장/초기화
  INIT_VIEWS_SRCH_DEPT_TREE: 'INIT_VIEWS_SRCH_DEPT_TREE', //* 부서 추가 팝업
  INIT_DEPT_USER_LIST: 'INIT_DEPT_USER_LIST', //* DEPT 직원 리스트데이터 초기화
  INIT_DEL_DEPT_HIDE: 'INIT_DEL_DEPT_HIDE',
};

//* MUTATIONS CONSTANT
export const mutations = {
  SET_DEPT_LIST: 'SET_DEPT_LIST', //* DEPT 리스트 데이터 세팅
  SET_DEPT_USER_LIST: 'SET_DEPT_USER_LIST', //* DEPT USER 리스트 데이터 세팅
  SET_DEPT_CODE: 'SET_DEPT_CODE', //* DEPT 코드 가져오기(중복체크)
  SET_DEPT_INFO: 'SET_DEPT_INFO', //* 부서 상세 정보 저장하기
  SET_VIEWS_SRCH_DEPT_TREE: 'SET_VIEWS_SRCH_DEPT_TREE', //* 부서 추가 팝업
  SET_ASSIGNED_DEPT: 'SET_ASSIGNED_DEPT', //* 연계부서 저장
  SET_DEL_DEPT_HIDE: 'SET_DEL_DEPT_HIDE',
};
